import { useEffect, useState } from "react";
import {
  createPath,
  removePath,
  renamePath,
  subscribeToDataCollection,
} from "../services/dataCollectionService";

export default function useDataCollection(collectionId) {
  const [dataCollection, setDataCollection] = useState(null);
  const [paths, setPaths] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!collectionId) return undefined;
    setIsLoading(true);
    setError("");

    return subscribeToDataCollection(
      collectionId,
      setDataCollection,
      (nextPaths) => {
        setPaths(nextPaths);
        setIsLoading(false);
      },
      (firebaseError) => {
        console.error("Unable to load data collection", firebaseError);
        setError("This collection could not be loaded. Check the public Firestore permissions and try again.");
        setIsLoading(false);
      },
    );
  }, [collectionId]);

  return {
    dataCollection,
    paths,
    isLoading,
    error,
    createPath: (path) => createPath(collectionId, path),
    renamePath: (pathId, name) => renamePath(collectionId, pathId, name),
    deletePath: (pathId) => removePath(collectionId, pathId),
  };
}

